import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../../common/html/checkbox'
import {
  changeListCheckedByArrId,
  selectIdsOfCurrentPage,
  selectListChecked,
} from '../../store/slice'

const CHECKBOX_MINUS_VALUE = -1

const CheckBoxAllCell = () => {
  const dispatch = useDispatch()

  const idsOfCurrentPage = useSelector(selectIdsOfCurrentPage)
  const listChecked = useSelector(selectListChecked)

  const checkedState = idsOfCurrentPage.map((id) => listChecked[id] ?? false)
  const isAllChecked = checkedState.every((state) => state)
  const isSomeChecked = checkedState.some((state) => state) && !isAllChecked

  const handleClick = () => {
    dispatch(
      changeListCheckedByArrId({
        keys: idsOfCurrentPage,
        checkedState: !isAllChecked && !isSomeChecked,
      }),
    )
  }

  return (
    <div>
      <Checkbox
        styleIcon={{ fontSize: 13, paddingRight: 16 }}
        checked={isSomeChecked ? CHECKBOX_MINUS_VALUE : isAllChecked}
        onChange={handleClick}
      />
    </div>
  )
}

export default CheckBoxAllCell
